<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :show-close="false"
    :width="width"
    :before-close="handleClose"
    :close-on-click-modal="isClickModal"
    :close-on-press-escape="isClickModal"
  >
    <img
      src="../../../static/image/closeBtn.png"
      alt=""
      class="closeImg"
      @click="handleClose()"
      v-if="isCloseBtn"
    />
    <slot name="content">
      <div v-html="infoData.content" class="content"></div>
    </slot>
  </el-dialog>
</template>

<script>
import { doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    isClickModal: {
      type: Boolean,
      default: true,
    },
    isCloseBtn: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "1000px",
    },
    isDefault: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      infoData: "",
    };
  },
  mounted() {
    if (this.isDefault) {
      this.getData(29);
    }
  },
  methods: {
    handleClose() {
      this.$emit("closepop"); //通知父组件改变。
    },
    getData(id) {
      var that = this;
      doGet(
        httpConfig.infoDetails.getDataUrl,
        { id: id },
        function (res) {
          that.infoData = res;
        },
        function (res) {}
      );
    },
  },
};
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 0;
  margin: 10vh auto 50px !important;
  /*position: absolute;
   margin-top: 0 !important;
  left: 50%;
  top: 50% !important;
  transform: translate(-50%, -50%); */
}
>>> .el-dialog__header {
  padding: 0;
}
>>> .el-dialog__body {
  border-top: 0;
  padding: 0;
  margin: 0;
  display: flex;
}
>>> .el-dialog__body p {
  margin: 0;
  display: flex;
}
.closeImg {
  width: 20px;
  height: 20px;
  position: absolute;
  top: -25px;
  right: -30px;
  cursor: pointer;
}
.content,
.content >>> p img {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/common/dialog.vue